import Api from '~/Api';
import localStorage from '~/services/storage/localStorage';

import AbstractStorage from './storage/AbstractStorage';

const USER_FIELDS_STORAGE_KEY = 'userFields';

type UserFields = {
  url: string;
  country: string;
};

class UserFieldsService {
  private _userFields: UserFields = {
    url: '',
    country: '',
  };
  private storage: AbstractStorage;

  constructor({ storage }: { storage: AbstractStorage }) {
    this.storage = storage;
    const userFields = this.storage.getByKey(USER_FIELDS_STORAGE_KEY);
    if (userFields) {
      this._userFields = JSON.parse(userFields);
    }
  }

  async init(): Promise<void> {
    if (!this._userFields.url) {
      this._userFields.url = window.location.pathname + window.location.search;
    }
    if (!this._userFields.country) {
      await this.fetchCountry();
    }
    this.saveToStorage();
  }

  updateUrl(url: string): void {
    this._userFields.url = url;
    this.saveToStorage();
  }

  get userFields(): UserFields {
    return this._userFields;
  }

  private async fetchCountry(): Promise<void> {
    const country = await Api.getCountry();
    this._userFields.country = country;
    this.saveToStorage();
  }

  private saveToStorage(): void {
    this.storage.setByKey(
      USER_FIELDS_STORAGE_KEY,
      JSON.stringify(this._userFields),
    );
  }
}

const userFieldsService = new UserFieldsService({ storage: localStorage });

export default userFieldsService;
